import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import type { IPlaylist } from "./types";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

interface IPlaylistRecord extends Pick<IPlaylist, '_id' | 'title' | 'totalSongCount'> {
    actions: unknown;
}

const BannerList = () => {

    const { handleInteraction, records, paginationState, deleteRecord } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<IPlaylistRecord>[] =  [
        {
            Header: 'Нэр',
            accessor: 'title',
        },
        {
            Header: 'Дууны тоо',
            accessor: 'totalSongCount',
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord} />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE} />
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default BannerList;